module.exports = __webpack_public_path__ + "img/feature_buy_cn.0c353ea6.png";